var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDotBlack = function SvgIconDotBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 6,
    fill: "none",
    viewBox: "0 0 6 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M.6 3.045q0-1.285.697-1.805.71-.52 1.709-.52.97 0 1.668.52.71.52.71 1.805 0 1.23-.71 1.777-.697.547-1.668.547-.998 0-1.71-.547Q.6 4.276.6 3.045"
  })));
};
export default SvgIconDotBlack;